// Intent to click on a link (i.e. click likely to happen soon) =
//       mouse hovered (without necessarily stopping) for 0.3s
//    OR mouse stopped moving completely over the element for 0.1s
//    OR element focused (via keyboard) for at least 0.2s
//    OR pointer down (equivalent to touchstart/mousedown) - might not resolve to a full click but likely does and triggers slightly earlier than the click
// (durations can be tweaked)

// Note: the intent detector can (and likely will) be triggered multiple times before and/or after the same click
//     ; do not run any uncached operations in the callback

export class IntentDetector {
	constructor(options) {
		this.options = {
			hover: 300,
			static: 100,
			focus: 200,
			getBaseEvent: null,
			...options
		};
		this.timers = {};
		this.trigger = this.trigger.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onMouseMove = this.onMouseMove.bind(this);
		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.onMouseLeave = this.onMouseLeave.bind(this);
		this.onPointerDown = this.onPointerDown.bind(this);
	}

	dispose() {
		this.clearTimer('focus');
		this.clearTimer('hover');
		this.clearTimer('static');
	}

	callBaseEvent(name, e) {
		this.options.getBaseEvent?.(name)?.(e);
	}

	resetTimer(name, time) {
		this.clearTimer(name);
		this.timers[name] = setTimeout(this.trigger, time);
	}
	clearTimer(name) {
		clearTimeout(this.timers[name]);
	}

	onFocus(e) {
		this.callBaseEvent('onFocus', e);
		this.resetTimer('focus', this.options.focus);
	}
	onBlur(e) {
		this.callBaseEvent('onBlur', e);
		this.clearTimer('focus');
	}

	onMouseMove(e) {
		this.callBaseEvent('onMouseMove', e);
		this.resetTimer('static', this.options.static);
	}
	onMouseEnter(e) {
		this.callBaseEvent('onMouseEnter', e);
		this.resetTimer('hover', this.options.hover);
	}
	onMouseLeave(e) {
		this.callBaseEvent('onMouseLeave', e);
		this.clearTimer('hover');
		this.clearTimer('static');
	}

	onPointerDown(e) {
		this.callBaseEvent('onPointerDown', e);
		this.trigger();
	}

	trigger() {
		this.options.onIntent?.();
	}

	get events() {
		return {
			onFocus: this.onFocus,
			onBlur: this.onBlur,
			onMouseMove: this.onMouseMove,
			onMouseEnter: this.onMouseEnter,
			onMouseLeave: this.onMouseLeave,
			onPointerDown: this.onPointerDown,
		};
	}
}